/*
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { loadState } from '@nextcloud/initial-state';
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        this.values = loadState('richdocuments', 'document', {});
    }
    ConfigService.prototype.update = function (key, value) {
        this.values[key] = value;
    };
    ConfigService.prototype.get = function (key) {
        return this.values[key];
    };
    return ConfigService;
}());
var Config = new ConfigService();
export default Config;
